import React, { useState } from "react";
import { Modal, Form, Input, Checkbox, Button, Typography } from "antd";
import { useCustomMutation } from "@refinedev/core";
import { PROCUREMENT_PLAN_VALIDATE_BUDGET_MUTATION } from "../queries";

const { Text } = Typography;

interface BudgetValidationDialogProps {
  visible: boolean;
  onClose: () => void;
  planId: string;
  totalAmount: number;
  onValidationSuccess: () => void;
}

export const BudgetValidationDialog: React.FC<BudgetValidationDialogProps> = ({
  visible,
  onClose,
  planId,
  totalAmount,
  onValidationSuccess,
}) => {
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  
  const { mutate: validateBudget, isLoading } = useCustomMutation();

  const handleValidate = async (values: any) => {
    if (!checked) {
      // Show error if checkbox is not checked
      form.setFields([
        {
          name: "confirmation",
          errors: ["Please confirm that you have checked and validated the budget"],
        },
      ]);
      return;
    }

    try {
      validateBudget({
        meta: {
          gqlMutation: PROCUREMENT_PLAN_VALIDATE_BUDGET_MUTATION,
        },
        values: {
          planId,
          totalAmount,
          remarks: values.remarks,
        },
        url: "",
        method: "post"
      }, {
        onSuccess: () => {
          onValidationSuccess();
          onClose();
          form.resetFields();
        },
      });
    } catch (error) {
      console.error("Error validating budget:", error);
    }
  };

  const handleCancel = () => {
    onClose();
    form.resetFields();
  };

  return (
    <Modal
      title="Validate Budget"
      visible={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="validate"
          type="primary"
          onClick={() => form.submit()}
          loading={isLoading}
          disabled={!checked}
        >
          Validate Budget
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={handleValidate}>
        <Form.Item>
          <Text strong>Total Amount: ETB {totalAmount.toLocaleString()}</Text>
        </Form.Item>
        
        <Form.Item
          name="confirmation"
          valuePropName="checked"
          rules={[
            {
              validator: (_) =>
                checked
                  ? Promise.resolve()
                  : Promise.reject(new Error("Please confirm the budget validation")),
            },
          ]}
        >
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          >
            I have checked and validated the budget for this plan
          </Checkbox>
        </Form.Item>
        
        <Form.Item
          label="Remarks (Optional)"
          name="remarks"
        >
          <Input.TextArea
            placeholder="Enter any additional remarks about the budget validation"
            rows={4}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};